import { initializeApp } from "firebase/app";
import {
  getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword,
  signOut, onAuthStateChanged,
  GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult,
  EmailAuthProvider, reauthenticateWithCredential, reauthenticateWithPopup,
  reauthenticateWithRedirect,
  deleteUser,
  browserPopupRedirectResolver
} from "firebase/auth";
import {
  getFirestore, doc, getDoc, setDoc, deleteDoc,
  collection, getDocs, addDoc, updateDoc, increment, limit,
  query, orderBy, where, serverTimestamp, deleteField,
  onSnapshot, arrayUnion, arrayRemove, writeBatch
} from "firebase/firestore";

const _fbConfig = {
  apiKey:            process.env.REACT_APP_FB_API_KEY,
  authDomain:        process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FB_APP_ID,
};

const _requiredFbKeys = ["apiKey","authDomain","projectId","storageBucket","messagingSenderId","appId"];
const _missingFbKeys = _requiredFbKeys.filter(k => !_fbConfig[k]);
if (_missingFbKeys.length > 0) {
  console.error(
    `[보안 오류] Firebase 환경변수가 설정되지 않았습니다: ${_missingFbKeys.join(", ")}\n` +
    `.env 파일에 REACT_APP_FB_* 변수를 설정하세요. 소스코드에 직접 입력하지 마세요.`
  );
}
const _fbApp = initializeApp(_fbConfig);
const fbAuth = getAuth(_fbApp);
const fbDb = getFirestore(_fbApp);

const FUNCTIONS_BASE = process.env.NODE_ENV === "development"
  ? "http://127.0.0.1:5001/travel-app-a1d28/asia-northeast3"
  : "https://asia-northeast3-travel-app-a1d28.cloudfunctions.net";

const getIdToken = async () => {
  const user = fbAuth.currentUser;
  if (!user) throw new Error("로그인 필요");
  return user.getIdToken();
};

export {
  fbAuth, fbDb, FUNCTIONS_BASE, getIdToken,
  createUserWithEmailAndPassword, signInWithEmailAndPassword,
  signOut, onAuthStateChanged,
  GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult,
  EmailAuthProvider, reauthenticateWithCredential, reauthenticateWithPopup,
  reauthenticateWithRedirect,
  deleteUser,
  browserPopupRedirectResolver,
  doc, getDoc, setDoc, deleteDoc,
  collection, getDocs, addDoc, updateDoc, increment, limit,
  query, orderBy, where, serverTimestamp, deleteField,
  onSnapshot, arrayUnion, arrayRemove, writeBatch
};
